import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<MiMap>({ })
export default class MiMap extends Vue {
  @Prop()
  protected isLoading!: boolean;

  @Prop()
  protected location!: '';

  @Prop({ default: 'No location available' })
  protected titleNoLocation!: string;

  @Prop({ default: 'medium' })
  protected size!: 'small' | 'medium' | 'large';

  protected get markers(): MapMarker[] {
    if (! this.location) { return []; }

    return [{ position: this.location }];
  }
}

interface MapMarker {
  position: '';
}
